console.log("Init");

function addDollarSignToMoneySpans() {
  const moneySpans = document.querySelectorAll('span.money');
  moneySpans.forEach(span => {
    // Check if the span is the last one and its parent doesn't start with "$"
    if (!span.querySelector('.money') && !span.parentElement.textContent.startsWith('$') && !span.textContent.startsWith('$')) {
      span.textContent = '$' + span.textContent;
    }
  });
}
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    addDollarSignToMoneySpans()
  }, 1000);
});